module.exports = __webpack_public_path__ + "img/photo-1519494080410-f9aa76cb4283.590d2cfd.jpeg";